<template>
  <div>
    <b-card-text><strong>{{ $t('อัตราการจ่ายรางวัล') }}</strong></b-card-text>
    <b-table
      :tbody-tr-class="lockedRowClass"
      responsive
      bordered
      :fields="$tFields(fields)"
      :items="items"
    >
      <template #cell(type)="data">
        <!-- 4/5 ตัว: สวิตช์เปิดประเภทนี้ในหวยนี้ · เป็นร่างจนกว่าจะกดบันทึกของตาราง -->
        <!-- 4/5 ตัว: กดไอคอนล็อกเพื่อเปิด/ปิดประเภทนี้ในหวยนี้ · เป็นร่างจนกว่าจะกดบันทึกของตาราง
             ไอคอนอยู่ขอบขวาตำแหน่งเดียวกับตารางเงื่อนไข ไม่ดันชื่อประเภท -->
        <div
          v-if="canToggleFourFive && isFourFiveDigit(data.value)"
          class="four-five-type"
        >
          {{ $tDisplay(betTypeLabel(data.value, options)) }}
          <button
            v-b-tooltip.hover
            type="button"
            class="four-five-lock four-five-lock-button"
            :title="fourFiveTooltip(data.value)"
            :aria-pressed="editableTypes.includes(data.value) ? 'true' : 'false'"
            :aria-label="$tDisplay(betTypeLabel(data.value, options))"
            @click="toggleFourFive(data.value, !editableTypes.includes(data.value))"
          >
            <feather-icon
              :icon="editableTypes.includes(data.value) ? 'UnlockIcon' : 'LockIcon'"
              :class="fourFiveIconClass(data.value)"
            />
          </button>
        </div>
        <div
          v-else
          class="four-five-type"
        >
          {{ $tDisplay(betTypeLabel(data.value, options)) }}
          <feather-icon
            v-if="isLocked(data.value)"
            v-b-tooltip.hover
            :title="$t('fourFiveDigit.locked')"
            icon="LockIcon"
            class="four-five-lock"
          />
        </div>
      </template>
      <template #cell(normal)="data">
        <div @click="editData(data.index,'normal')">
          {{ data.value }}
        </div>
      </template>
      <template #cell(vip1)="data">
        <div @click="editData(data.index,'vip1')">
          {{ data.value }}
        </div>
      </template>
      <template #cell(vip2)="data">
        <div @click="editData(data.index,'vip2')">
          {{ data.value }}
        </div>
      </template>
      <template #cell(vip3)="data">
        <div @click="editData(data.index,'vip3')">
          {{ data.value }}
        </div>
      </template>
      <template #cell(vip4)="data">
        <div @click="editData(data.index,'vip4')">
          {{ data.value }}
        </div>
      </template>
    </b-table>

    <div class="text-right">
      <b-button
        v-if="$can('update', 'lotto.rate')"
        v-ripple.400="'rgba(255, 255, 255, 0.15)'"
        type="submit"
        variant="primary"
        class="mt-1"
        @click.prevent="saveEdit"
      >
        <feather-icon
          icon="SaveIcon"
          class="mr-50"
        />
        <span class="align-middle">{{ $t('Submit') }}</span>
      </b-button>
    </div>

    <b-modal
      v-model="showModal"
      cancel-variant="secondary"
      ok-only
      :ok-title="$t('Ok')"
      centered
      size="xs"
      :title="$t('เเก้ไข')"
      button-size="sm"
      @ok="submitEdit"
      @hidden="modalTextError=''"
    >
      <b-form-input
        v-model="modalText"
        autofocus
        type="number"
        @keypress.enter="submitEdit"
      />
      <small
        v-if="modalTextError !== ''"
        class="text-danger"
      >{{ modalTextError }}</small>
    </b-modal>
  </div>
</template>

<script>
/* eslint-disable dot-notation */

import {
  BButton, BCardText, BFormInput, BModal, BTable, VBTooltip,
} from 'bootstrap-vue'
import Ripple from 'vue-ripple-directive'
import lottoService from '@/service/lottoService'
import { getUserData } from '@/auth/utils'
import fourFiveDigitService, { canManageFourFiveDigit } from '@/service/fourFiveDigitService'
import {
  betTypeLabel, splitNewRateRows, isFourFiveDigit, isLockedFourFiveDigit,
} from '@/utils/betTypes'
import ToastificationContent from '@core/components/toastification/ToastificationContent.vue'

export default {
  components: {
    BTable,
    BButton,
    BModal,
    BFormInput,
    BCardText,
  },
  directives: {
    Ripple,
    'b-tooltip': VBTooltip,
  },
  props: {
    // 4/5 ตัว: ประเภทที่แก้ได้ (ติ๊กเปิดในหวยนี้แล้ว) · ประเภทใหม่ที่ไม่อยู่ในนี้แสดงอย่างเดียว
    // สวิตช์ในแถวแก้ค่านี้เป็นร่าง (.sync) ตารางเงื่อนไขจึงล็อก/ปลดล็อกตามทันที
    editableTypes: {
      type: Array,
      default: () => [],
    },
    // แถวตั้งค่ารายหวยจาก four-five-digit/huay (มีเฉพาะผู้ที่ตั้งค่าได้) · null = แสดงสถานะอย่างเดียว
    fourFiveSetting: {
      type: Object,
      default: null,
    },
    huayData: {
      type: Object,
      default: null,
    },
    huayRate: {
      type: Array,
      default: null,
    },
  },
  data() {
    return {
      options: [
        'สามตัวบน',
        'สามตัวโต้ด',
        'สามตัวหน้า',
        'สามตัวท้าย',
        'สองตัวบน',
        'สองตัวล่าง',
        'วิ่งบน',
        'วิ่งล่าง',
      ],
      fields: [
        {
          key: 'type',
          label: 'ประเภท',
          class: 'text-nowrap text-center',
        },
        {
          key: 'normal',
          label: 'ปกติ',
          class: 'text-center',
        },
        {
          key: 'vip1',
          label: 'vip1',
          class: 'text-center',
        },
        {
          key: 'vip2',
          label: 'vip2',
          class: 'text-center',
        },
        {
          key: 'vip3',
          label: 'vip3',
          class: 'text-center',
        },
        {
          key: 'vip4',
          label: 'vip4',
          class: 'text-center',
        },
      ],
      items: [],
      focusableObj: {
        row: 0,
        key: '',
      },
      showModal: false,
      modalText: '',
      modalTextError: '',
    }
  },
  computed: {
    canToggleFourFive() {
      return !!this.fourFiveSetting && canManageFourFiveDigit(getUserData())
    },
    // สวิตช์ที่ยังไม่ได้บันทึก — ส่งเฉพาะประเภทที่หวยนี้เปิดได้
    fourFiveDraft() {
      const allowed = (this.fourFiveSetting && this.fourFiveSetting.allowedTypes) || []
      return allowed.filter(type => this.editableTypes.includes(type))
    },
    fourFiveChanged() {
      return this.canToggleFourFive
        && (this.fourFiveSetting.allowedTypes || []).some(type => this.isFourFiveDirty(type))
    },
  },
  mounted() {
    this.items = this.huayRate
    if (this.huayData.type === 5) {
      this.options = [
        '4 ตัวตรง',
        '3 ตัวตรง',
        '4 ตัวโต๊ด',
        '3 ตัวโต๊ด',
        // "3 ตัวหน้าตรง",
        '2 ตัวหน้า',
        '2 ตัวหลัง',
      ]
    }
  },
  methods: {
    betTypeLabel,
    isFourFiveDigit,
    toggleFourFive(type, on) {
      const next = this.editableTypes.filter(v => v !== type)
      this.$emit('update:editableTypes', on ? next.concat(type).sort((a, b) => a - b) : next)
    },
    // สถานะ + สิ่งที่จะเกิดเมื่อกด + แก้ไขล่าสุด / จำนวนหลักของผลหลัก
    fourFiveTooltip(type) {
      const setting = this.fourFiveSetting
      const state = this.$t(`fourFiveDigit.lotto.${this.editableTypes.includes(type) ? 'on' : 'off'}`)
      const updated = setting.updatedAt
        ? this.$t('fourFiveDigit.lotto.updated', { at: setting.updatedAt, by: setting.updatedBy || '-' })
        : this.$t('fourFiveDigit.lotto.never')
      return [
        state,
        this.isFourFiveDirty(type) ? this.$t('fourFiveDigit.lotto.dirty') : '',
        updated,
        setting.resultLength ? this.$t('fourFiveDigit.lotto.resultDigits', { count: setting.resultLength }) : '',
      ].filter(Boolean).join(' · ')
    },
    // ส้ม = ยังไม่ได้บันทึก · เขียว = เปิด · จาง = ปิด
    fourFiveIconClass(type) {
      if (this.isFourFiveDirty(type)) return 'text-warning'
      return this.editableTypes.includes(type) ? 'text-success' : 'text-muted'
    },
    isFourFiveDirty(type) {
      const saved = (this.fourFiveSetting && this.fourFiveSetting.enabledTypes) || []
      return this.editableTypes.includes(type) !== saved.includes(type)
    },
    // บันทึกสวิตช์หลังอัตราจ่ายบันทึกสำเร็จ ลูกค้าจึงไม่เห็นประเภทใหม่ก่อนมีอัตรา
    async saveFourFiveSetting(id) {
      const failed = text => this.$toast({
        component: ToastificationContent,
        position: 'top-right',
        props: {
          title: this.$t('เกิดข้อผิดพลาด'),
          icon: 'AlertCircleIcon',
          variant: 'danger',
          text: `${this.$t('fourFiveDigit.lotto.saveError')}${text ? `: ${text}` : ''}`,
        },
      })
      try {
        const res = await fourFiveDigitService.saveHuaySetting(id, this.fourFiveDraft)
        if (!res || res.status !== 200) {
          failed(res && typeof res.data === 'string' ? res.data : '')
          return
        }
        // เวลาและผู้แก้ล่าสุดมาจาก server · อ่านไม่สำเร็จก็ใช้ค่าที่เพิ่งบันทึก
        const rows = await fourFiveDigitService.huaySettings().then(r => (r && r.status === 200 ? r.data : null)).catch(() => null)
        const row = Array.isArray(rows) && rows.find(v => String(v.id) === String(id))
        this.$emit('update:fourFiveSetting', row || { ...this.fourFiveSetting, enabledTypes: this.fourFiveDraft })
      } catch (error) {
        failed('')
      }
    },
    isLocked(type) {
      return isLockedFourFiveDigit(type, this.editableTypes)
    },
    lockedRowClass(item) {
      return item && this.isLocked(item.type) ? 'text-muted' : ''
    },
    editData(row, key) {
      if (this.isLocked(this.items[row].type)) return
      this.showModal = true
      this.focusableObj.row = row
      this.focusableObj.key = key
      this.modalText = this.items[row][key]
    },
    submitEdit(bvModalEvt) {
      bvModalEvt.preventDefault()
      if (this.modalText * 1 < 0) {
        this.modalTextError = this.$t('ตัวเลขต้องมีค่าตั้งเเต่ 0 ขึ้นไป')
      } else {
        const { row, key } = this.focusableObj
        this.items[row][key] = this.modalText
        this.showModal = false
      }
    },
    saveEdit() {
      const { id } = this.$route.query
      // 4/5 ตัว: แถวใหม่ต้องตั้งเงื่อนไขการแทงให้ครบก่อน server จึงจะสร้างแถวให้
      const { rows, incomplete } = splitNewRateRows(this.huayRate)
      if (incomplete.length > 0) {
        this.$toast({
          component: ToastificationContent,
          position: 'top-right',
          props: {
            title: this.$t('เกิดข้อผิดพลาด'),
            icon: 'AlertCircleIcon',
            variant: 'danger',
            text: `${this.$t('ตั้งเงื่อนไขการแทงให้ครบก่อนบันทึก')}: ${incomplete.map(type => this.$tDisplay(betTypeLabel(type))).join(', ')}`,
          },
        })
        return
      }
      if (id) {
        this.$swal({
          dark: true,
          title: this.$t('Are you sure?'),
          text: this.$t('คุณเเน่ใจว่าต้องการบันทึกข้อมูลใช่หรือไม่'),
          icon: 'info',
          showCancelButton: true,
          confirmButtonText: this.$t('Ok'),
          customClass: {
            confirmButton: 'btn btn-primary',
            cancelButton: 'btn btn-outline-danger ml-1',
          },
          buttonsStyling: false,
        }).then(async result => {
          if (result.value) {
            // eslint-disable-next-line no-restricted-syntax
            for (const v of rows) {
              v.normal *= 1
              // v.inverse *= 1;
              v.vip1 *= 1
              v.vip2 *= 1
              v.vip3 *= 1
              v.vip4 *= 1
            }
            const res = await lottoService.putAuthen(
              `rate/reward/${id}`,
              rows,
            )
            if (res.status === 200 && this.fourFiveChanged) await this.saveFourFiveSetting(id)
            if (res.status === 200) {
              this.$toast({
                component: ToastificationContent,
                position: 'top-right',
                props: {
                  title: this.$t('สำเร็จ'),
                  icon: 'CoffeeIcon',
                  variant: 'success',
                  text: this.$t('บันทึกข้อมูสำเร็จ'),
                },
              })
            } else {
              this.$toast({
                component: ToastificationContent,
                position: 'top-right',
                props: {
                  title: this.$t('เกิดข้อผิดพลาด'),
                  icon: 'AlertCircleIcon',
                  variant: 'danger',
                  text: res.data,
                },
              })
            }
          }
        })
      }
    },
  },
}
</script>

<style lang="scss" scoped>
// ไอคอนล็อกวางทับขอบขวาของช่อง ไม่ดันชื่อประเภท แถวทั้งหมดจึงตรงกัน
.four-five-type {
  position: relative;
}

.four-five-lock {
  position: absolute;
  top: 50%;
  right: 0;
  transform: translateY(-50%);
}

.four-five-lock-button {
  padding: 0;
  border: 0;
  background: none;
  line-height: 1;
  cursor: pointer;
}
</style>

<style lang="scss">
@import '@core/scss/vue/libs/vue-sweetalert.scss';
</style>
